import ResultRow from "../Table/ResultRow";
import ResultBodyCell from "../Table/ResultBodyCell";
import {InputNumber} from "antd";


export default function getSettingsItem({value, onChange, defaultValue, label, description, min, max}) {
    return (
        <ResultRow>
            <ResultBodyCell style={{textAlign: 'start'}}>
                {label}
            </ResultBodyCell>
            <ResultBodyCell>
                <InputNumber
                    controls={false}
                    value={value}
                    onChange={onChange}
                    min={min}
                    max={max}
                />
            </ResultBodyCell>
            <ResultBodyCell style={{textAlign: 'center'}}>
                <div style={{fontStyle: 'italic', color: '#00000088', textAlign: 'left', marginLeft: 4}}>
                    {defaultValue}
                </div>
            </ResultBodyCell>
            <ResultBodyCell>
                {description}
            </ResultBodyCell>
        </ResultRow>
    )
}